var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('info-pane-action-btn',{attrs:{"loading":_vm.downloading,"icon":"bx-download","label":_vm.label},on:{"click":_vm.doDownload}})}
var staticRenderFns = []

export { render, staticRenderFns }